import * as Layout from './aspects/responsiveLayout/responsiveLayout'
import * as ResponsiveStyles from './aspects/responsiveStyles/responsiveStyles'
import * as Breakpoints from './aspects/breakpoints/breakpoints'
import * as ImageX from './aspects/imageX/imageX'
import * as ResponsiveBaseAnchor from './aspects/responsiveBaseAnchor/responsiveBaseAnchor'
import * as responsiveComponentsExtensions from './aspects/responsiveComponentsExtensions/responsiveComponentsExtensions'
import * as responsiveSiteAPIExtension from 'bolt-responsive/src/aspects/siteAPI/responsiveSiteAPIExtension'
import * as WindowScrollAsCssVariable from './aspects/windowScrollAsCssVariable/windowScrollAsCssVariable'

export const runtime = {
    responsiveComponentsExtensions,
    Layout,
    Breakpoints,
    ImageX,
    ResponsiveStyles,
    ResponsiveBaseAnchor,
    WindowScrollAsCssVariable
}

export const dsRuntime = Object.values(Object.assign({},
    runtime,
    {responsiveSiteAPIExtension}
))
